export const tryParseNumber = str => {
  if (str != null && str != undefined && !isNaN(str)) {
    return Number(str);
  }

  return null;
};

export const tryParseNumberAllowZero = str => {
  if (str === '0' || str === 0) {
    return 0;
  } else {
    return tryParseNumber(str);
  }
};

export const tryParseNumberNullEmpty = str => {
  if (str === '') {
    return null;
  } else {
    return tryParseNumberAllowZero(str);
  }
};

export const tryParseArray = (arr, defaultValue) => {
  if (arr && Array.isArray(arr)) {
    return arr.filter(v => v !== null);
  }
  if (arr) {
    return [arr];
  }

  return defaultValue || [];
};

export const tryParseNumberArray = (arr, defaultValue) => {
  if (arr && Array.isArray(arr)) {
    return arr.map(v => tryParseNumber(v, null)).filter(v => v !== null);
  }

  return defaultValue || [];
};

export const tryParseString = str => {
  if (str && str.length > 0) {
    return str;
  } else {
    return null;
  }
};

export const transformToString = value => {
  if (value != undefined && value != null) {
    return value.toString();
  } else {
    return null;
  }
};

export const parseMultiRef = (serialized, prefix) => {
  const multiRefIdField = serialized[`${prefix}.ref`];
  const multiRefValues = serialized[`${prefix}.ids[]`];
  const multiRefOther = serialized[`${prefix}.other`];

  return Object.assign({
    ref: parseInt(multiRefIdField, 10),
    ids: tryParseNumberArray(multiRefValues),
    other: multiRefOther,
  });
};

export const parseComplexMultiRef = (serialized, values, prefix) => {
  const complexRefIdField = serialized[`${prefix}.ref`];
  const complexRefs = serialized[`${prefix}.complex_refs[].ref`];
  const complexIndexedRefs = serialized[`${prefix}.complex_refs[].ref_values`];
  const complexText1 = serialized[`${prefix}.complex_refs[].text1`];
  const complexText2 = serialized[`${prefix}.complex_refs[].text2`];

  let complexRefArray = complexRefs;
  if (complexRefs && !Array.isArray(complexRefs)) {
    complexRefArray = [complexRefs];
  }

  if (complexRefArray && Array.isArray(complexRefArray)) {
    const formattedRefs = complexRefArray
      .map((ref, _) => {
        const withRef = tryParseNumber(ref, null);

        if (withRef) {
          const indexed = complexIndexedRefs.find(o => {
            return (
              tryParseNumber(o.value, null) &&
              tryParseNumber(o.value, null) === withRef
            );
          });

          if (indexed) {
            return Object.assign({
              ref: withRef,
              text1: complexText1[indexed.index].value,
              text2: complexText2[indexed.index].value,
            });
          }
        }
        return undefined;
      })
      .filter(v => !!v);

    return Object.assign({
      ref: parseInt(complexRefIdField, 10),
      complex_refs: formattedRefs,
    });
  }

  return Object.assign({
    ref: parseInt(complexRefIdField, 10),
    complex_refs: [],
  });
};



// WEBPACK FOOTER //
// ./src/utils/parse.js